module.exports = __webpack_public_path__ + "static/snow-camp-5c6fafeac465c6b1f4d7735875f9cdf2.png";